import { Megaphone, Trophy, TrendingDown, Car, Radio, GitBranch, UploadCloud, Warehouse, KeyRound, AlertTriangle } from "lucide-react";
import { fmtN, fmtP, heatCell } from "./Momentum";

const STAGES = [["enquiry", "Enq"], ["test_drive", "TD"], ["booking", "Bkg"], ["retail", "Retail"]];

export function WeekStrip({ weeks }) {
  return (
    <div className="border bg-card rounded-md overflow-auto" data-testid="ov-week-strip">
      <div className="px-4 py-3 border-b"><h3 className="font-heading text-sm font-semibold">F · Week-wise plan vs achieved <span className="text-muted-foreground font-normal text-xs">· W1–W4 split from the approved plans · current week highlighted with what is still needed</span></h3></div>
      <div className="grid grid-cols-2 lg:grid-cols-4 divide-x min-w-[560px]">
        {weeks.map((w) => (
          <div key={w.week} className={`p-3 ${w.current ? "bg-amber-50/70 ring-1 ring-inset ring-amber-300" : w.future ? "text-muted-foreground" : ""}`} data-testid={`ov-week-${w.week}`}>
            <div className="flex items-center justify-between mb-1.5">
              <span className="font-heading font-bold text-sm">{w.week} <span className="text-[10px] font-normal text-muted-foreground">{w.start}–{w.end}</span></span>
              {w.current && <span className="rounded bg-amber-200 text-amber-900 px-1.5 py-0.5 text-[9px] font-bold uppercase" data-testid="ov-week-current">now · {w.remaining_wd} wd left</span>}
              {w.done && <span className="text-[9px] uppercase text-muted-foreground">done</span>}
            </div>
            <table className="w-full text-[11px]">
              <tbody>
                {STAGES.map(([k, l]) => {
                  const c = w.cells[k];
                  return (
                    <tr key={k}>
                      <td className="py-0.5 text-muted-foreground w-10">{l}</td>
                      <td className="py-0.5 text-right num"><b>{fmtN(c.ach)}</b> <span className="text-muted-foreground">/ {fmtN(c.plan)}</span></td>
                      <td className={`py-0.5 text-right num font-semibold w-14 ${w.future ? "" : heatCell(c.pct)}`}>{w.future ? "—" : fmtP(c.pct)}</td>
                      {w.current && <td className="py-0.5 text-right num text-amber-900 w-16 whitespace-nowrap" data-testid={`ov-week-need-${k}`}>{c.remaining ? `need ${fmtN(c.remaining)}` : "✓"}</td>}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
}

const ICON = { top: Trophy, bottom: TrendingDown, model: Car, source: Radio, conversion: GitBranch, upload: UploadCloud, ok: UploadCloud, bays: Warehouse, td: KeyRound, td_idle: AlertTriangle };

export function CallOuts({ items, period, title = "G · Call-outs" }) {
  return (
    <div className="border bg-card rounded-md" data-testid="ov-callouts">
      <div className="px-4 py-3 border-b"><h3 className="font-heading text-sm font-semibold flex items-center gap-1.5"><Megaphone size={14} /> {title}{period?.kind === "week" && <span className="text-muted-foreground font-normal text-xs">· on {period.week} figures</span>}</h3></div>
      <ul className="p-4 space-y-2 text-xs">
        {items.map((c, i) => {
          const Icon = ICON[c.kind] || Megaphone;
          return <li key={i} className="flex items-start gap-2" data-testid={`ov-callout-${c.kind}`}><Icon size={13} className={`mt-0.5 shrink-0 ${c.kind === "bottom" || c.kind === "upload" ? "text-red-600" : c.kind === "top" || c.kind === "ok" ? "text-emerald-700" : "text-amber-700"}`} /><span>{c.text}</span></li>;
        })}
        {items.length === 0 && <li className="text-muted-foreground">Nothing to flag yet — call-outs appear once plans are approved and uploads come in.</li>}
      </ul>
    </div>
  );
}
